import {
  initEmptyData,
  inputActions,
} from '../store/actions/modelsActions/control'
import { configsActions } from '../store/slices/configsSlice'

interface IInputDataDispatcher {
  isEmpty: boolean
  name: string
  path: string[]
  dataSchema: any
  inputState: any
  validationCheck: any
  guid: string
  errorKey: string
  isUndefined: boolean
  data: any
  checkPath?: string[]
  type?: string
}

export function inputDataDispatcher(
  data: IInputDataDispatcher,
  dispatch: Function
) {
  const {
    isEmpty,
    name,
    path,
    dataSchema,
    data: dataPrev,
    inputState,
    validationCheck,
    guid,
    errorKey,
    isUndefined,
    checkPath,
    type,
  } = data
  const { is_empty_as_null: isEmptyAsNull } = dataSchema
  const tabName: string = path[2]

  if (path.length > 2) {
    if (isEmpty) {
      dispatch(initEmptyData({ name, path, schema: dataSchema }))
    }
    if (dataPrev?.[name] !== inputState?.[name]) {
      dispatch(
        inputActions.modify(
          inputState,
          path,
          inputState,
          name,
          type,
          isEmptyAsNull
        )
      )
    }
    if (!validationCheck?.isValidSync(inputState?.[name])) {
      dispatch(configsActions.setConfigInvalid({ guid, tabName, errorKeyName: errorKey }))
    }
    if (validationCheck?.isValidSync(inputState?.[name]) && !isUndefined) {
      dispatch(configsActions.setConfigValid({ guid, tabName, errorKeyName: errorKey }))
    }
  } else {
    dispatch(
      configsActions.setConfigValid({
        guid: checkPath?.[0] || '',
        tabName: checkPath?.[2] || '',
        errorKeyName: (checkPath || []).join('')
      })
    )
  }
}
